import React, {useState} from 'react';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Button, Divider, Layout, Text, Icon } from '@ui-kitten/components';
import { StyleSheet, ScrollView, Image, Dimensions, View } from 'react-native';
import { setTaskStatus } from '../../../store/actions/request';
import trackerApi from '../../api/tracker';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { showMessage, hideMessage } from "react-native-flash-message";

import {useSelector, useDispatch} from 'react-redux';


  const CardIcon = (props) => (
    <Icon {...props}  name='credit-card'/>
  );


const  width= Dimensions.get('window').width-40
export const Doing = () => {
  const data = useSelector( state => state.request.data);
  const dispatch = useDispatch();
  return (
      <Layout level='3' style={styles.container}>
        <View style={{justifyContent:'space-between', alignItems:'center', flex:1}}>
          <Image source= {require('../../../assets/invoice.png')} style={{width:width*0.7, height:width*0.7, marginVertical:25}} />
          <Button  style={{width, borderRadius:10}} onPress={async ()=>{
            const token =  await AsyncStorage.getItem('userId');
            const response0 = await trackerApi.post('/update/request_status', {reqID: data.id, status: 'doing'}, {
              headers: {Authorization: `Bearer ${token}`}
            });
            if (response0.data.status) dispatch(setTaskStatus('doing'))
            else {
              showMessage({
                message: `خطای دیتابیس`,
                type: "danger",
              })
            }
          }}> مراجعه و ثبت فاکتور</Button>
        </View>
      </Layout>
  );
};

const styles = StyleSheet.create({
  container:{
    flex:1,
    justifyContent:'space-around',
    alignItems:'center'
  },
});
